import { useEffect, useState, useCallback } from "react";
import PubSub from "../../../services/PubSub";
import { Toast, ToastContainer } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DeploymentInfoToast = () => {
    const [translate] = useTranslation();
    const [deployments, setDeployments] = useState([]);
    const [hidden, setHidden] = useState(false);
    const defaultTitle = "OTM_DEPLOYMENT_STATUS";

    useEffect(() => {
        const id_1 = PubSub.subscribe("hide-deployment-toasts", () => {
            setHidden(true);
        });

        const id_2 = PubSub.subscribe("show-deployment-toasts", () => {
            setHidden(false);
        });

        return () => {
            PubSub.unsubscribe("hide-deployment-toasts", id_1);
            PubSub.unsubscribe("show-deployment-toasts", id_2)
        };
    }, []);

    useEffect(() => {
        const showId = PubSub.subscribe("show_deployment_info", (deploymentId, text, title) => {
            const index = deployments.findIndex(d => d.id === deploymentId);
            if (index !== -1) {
                if (text !== deployments[index].info) {
                    setDeployments(prevState => {
                        return prevState.map(
                            el => el.id === deploymentId ? { ...el, info: text, title: title ? title : el.title, show: true } : el
                        )
                    });
                }
            }
            else {
                setDeployments(prevState => {
                    return [...prevState, {
                        id: deploymentId,
                        info: text,
                        title: title ? title : defaultTitle,
                        show: true
                    }]
                });
            }
        });

        return () => {
            PubSub.unsubscribe("show_deployment_info", showId);
        }
    }, [translate, deployments]);

    const hideVisibility = useCallback((deploymentId) => {
        setDeployments(prevState => {
            return prevState.map(
                el => el.id === deploymentId ? { ...el, show: false } : el
            )
        });
    }, []);

    return (
        <ToastContainer className="p-3" position="bottom-end">
            {
                deployments.length > 0 ? deployments.map((deployment) => (
                    <Toast
                        onClose={() => hideVisibility(deployment.id)}
                        show={deployment.show && !hidden}
                        animation={false}
                        bg="light"
                        key={deployment.id}>
                        <Toast.Header>
                            <label className="me-auto h6 text-primary">{translate(deployment.title)} - {deployment.id}</label>
                        </Toast.Header>
                        <Toast.Body>{deployment.info}</Toast.Body>
                    </Toast>
                )) : <></>
            }
        </ToastContainer>
    );

};

export default DeploymentInfoToast;
